import { useState, useEffect } from 'react';

const STORAGE_KEY = 'listingContactModalLastShown';
const TWO_MONTHS_MS = 60 * 24 * 60 * 60 * 1000;
const SIX_MINUTES_MS = 6 * 60 * 1000;

const useListingContactModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    // Check if we should show the modal
    const lastShown = localStorage.getItem(STORAGE_KEY);
    const now = Date.now();

    if (!lastShown || now - parseInt(lastShown) > TWO_MONTHS_MS) {
      // Start the 8-minute timer
      const newTimer = setTimeout(() => {
        setIsModalOpen(true);
        // Store the current time when showing the modal
        localStorage.setItem(STORAGE_KEY, now.toString());
      }, SIX_MINUTES_MS);

      setTimer(newTimer);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return {
    isModalOpen,
    handleClose,
  };
};

export default useListingContactModal;
